import React from "react";
import { useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
// import RegisterMembership from "./membership/RegisterMembership";
import ManageMembership from "./membership/ManageMembership";
import PreviewMembership from "./membership/PreviewMembership";

const Membership = () => {
  const { user } = useSelector((state) => state.USER_DATA);
  // const location = useLocation();

  // If user is NOT logged in → show Preview Register page
  if (!user) {
    return <PreviewMembership />;
  }

  // if (location.state?.showRegisterMembership) {
  //   return <RegisterMembership />;
  // }
  // If user IS logged in → show Membership section
  return (
    <>
      <ManageMembership />
    </>
  );
};

export default Membership;
